// Nested action items on mobile (site QA / surveillance). Category + detail match the web nested form.
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useForm } from "react-final-form";
import _ from "lodash";

import { FieldArray } from "react-final-form-arrays";
import { InputField, ListArray, required, SmartSelect, ReactDropzone } from "modules/4_final_form/mobile";
import { getProjectQaActionItemsCategories } from "modules/project/qa/action_items/categories/actions";

function mapStateToProps(state) {
  return {
    project_qa_action_items_categories: state.project_qa_action_items_categories,
  };
}

const CategorySmartSelect = (props) => {
  const form = useForm();
  return (
    <SmartSelect
      {...props}
      input={{
        ...props.input,
        onChange: (value) => {
          props.input.onChange(value);
          form.change(props.input.name.replace(/category_id$/, "category_detail_id"), null);
        },
      }}
    />
  );
};

const ActionItemsFieldArray = (props) => {
  const { name, users, project_qa_action_items_statuses, handleSubmit, addProps, project_qa_action_items_categories } = props;

  useEffect(() => {
    props.getProjectQaActionItemsCategories();
  }, []);

  const columns = (thisField) => {
    const categorySelected = _.find(project_qa_action_items_categories, (c) => c.id == thisField?.category_id);
    const hasDetails = _.some(categorySelected?.details_attributes, (d) => d?.id);
    const cols = [
      {
        name: "description",
        label: "Description",
        type: "textarea",
        placeholder: "Type description here...",
        component: InputField,
        validate: required,
      },
      {
        name: "user_links_attributes",
        label: "User/s Responsible",
        component: SmartSelect,
        type: "select",
        multi: true,
        labelName: "label",
        valueName: "value",
        options: _.map(users, (user) => {
          return {
            label: user.name,
            value: user.id,
            user_id: user.id,
          };
        }),
      },
      {
        name: "status_id",
        label: "Status",
        placeholder: "Select status",
        component: SmartSelect,
        type: "select",
        labelName: "label",
        valueName: "value",
        validate: required,
        openIn: "popover",
        options: _.map(project_qa_action_items_statuses, (status) => {
          return {
            label: status.name,
            value: status.id,
          };
        }),
      },
      {
        name: "category_id",
        label: "Category",
        placeholder: "Select category",
        component: CategorySmartSelect,
        type: "select",
        labelName: "label",
        valueName: "value",
        openIn: "popover",
        options: _.map(project_qa_action_items_categories, (cat) => {
          return {
            label: cat.name,
            value: cat.id,
          };
        }),
      },
    ];

    if (hasDetails) {
      cols.push({
        name: "category_detail_id",
        label: "Detail",
        placeholder: "Select detail",
        component: SmartSelect,
        type: "select",
        labelName: "label",
        valueName: "value",
        validate: required,
        openIn: "popover",
        options: _.map(categorySelected?.details_attributes, (detail) => {
          return {
            label: detail.name,
            value: detail.id,
          };
        }),
      });
    }

    cols.push({
      name: "attachments_attributes",
      label: "Attachments",
      fieldArray: true,
      component: ReactDropzone,
      array: true,
      uploadNow: true,
    });

    return cols;
  };

  return (
    <FieldArray
      component={ListArray}
      name={name}
      columns={columns}
      label="Action Items"
      itemLabel="Action Item"
      buttonLabel="Add Action Item"
      handleSubmit={handleSubmit}
      addProps={addProps}
    />
  );
};

export default connect(mapStateToProps, { getProjectQaActionItemsCategories })(ActionItemsFieldArray);
